export default {
  // 维保状态
  planState: [
    { label: '全部', value: '' },
    { label: '已失效', value: 2 },
    { label: '生效中', value: 1 }
  ],
  // 维保方案详情基本信息
  list: [
    { key: 'planName', name: '方案名称' },
    { key: 'planId', name: '方案ID' },
    { key: 'providerName', name: '维修厂名称' },
    { key: 'createTime', name: '创建时间' },
    { key: 'stateName', name: '方案状态' },
    { key: 'orderCycle', name: '订单有效期' },
    { key: 'invalidTime', name: '解约时间' }
  ],
  // 维保方案套餐信息展示
  comboList: [
    { label: '套餐名称', value: 'packageName' },
    { label: '套餐价格（元）', value: 'packageAmount' },
    { label: '协议价（元）', value: 'packageAgreeAmount' },
    { label: '维保类型', value: 'maintenanceTypeName' }
  ]
}
